import script from "./add-units.vue?vue&type=script&setup=true&lang=js"
export * from "./add-units.vue?vue&type=script&setup=true&lang=js"

import "./add-units.vue?vue&type=style&index=0&id=01f5366b&lang=scss&scoped=true"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f5366b"]])

export default __exports__